<template>

    <div>
        <div class="box box-solid">
            <div class="box-header">
                <h2 class="box-title">Liquiditeit</h2>
                <div class="box-tools">
                    <div class="btn-group btn-group-sm">
                        <json-excel
                            :data="getJSONData"
                            :name="getExportName()"
                            v-tooltip="'Exporteren naar Excel'"
                            class="btn btn-default"
                        >
                            <i class="mdi mdi-file-excel-box"></i>
                        </json-excel>
                    </div>
                    <div class="btn-group btn-group-sm" v-if="Object.keys(getSpanningYears).length > 1">
                        <button
                            class="btn btn-default"
                            v-for="(colspan, year) in getSpanningYears"
                            v-text="year"
                            @click="setYearView(year)"
                        ></button>
                    </div>
                    <div class="btn-group btn-group-xs">
                        <button class="btn btn-default" @click="moveBackwardsYear()" data-tooltip="tooltip" title="Een jaar terug"><i class="fa fa-angle-double-left"></i></button>
                        <button class="btn btn-default" @click="moveBackwards()" data-tooltip="tooltip" title="Een maand terug"><i class="fa fa-angle-left"></i></button>
                        <button class="btn btn-default" @click="moveReset()" v-show="isResetable" data-tooltip="tooltip" title="Terugzetten">Reset</button>
                        <button class="btn btn-default" @click="moveForward()" data-tooltip="tooltip" title="Een maand vooruit"><i class="fa fa-angle-right"></i></button>
                        <button class="btn btn-default" @click="moveForwardYear()" data-tooltip="tooltip" title="Een jaar vooruit"><i class="fa fa-angle-double-right"></i></button>
                    </div>
                </div>
            </div>
            <div class="box-body no-padding">
                <table class="table table-striped table-hover table-condensed table-bordered centered-table-headers table-fixed">
                    <thead>
                        <tr>
                            <th rowspan="2" colspan="2">Onderdeel</th>
                            <th v-for="(colspan, year) in getSpanningYears" :colspan="colspan">{{ year }}</th>
                            <th rowspan="2">Totaal</th>
                        </tr>
                        <tr>
                            <th v-for="addmonth in 12" :class="{'bg-info':isCurrentMonth(addmonth)}">{{ moment(startperiod).add(addmonth - 1, "month").format("MMM") }}</th>
                        </tr>
                    </thead>
                    <tbody v-if="!loading && startperiod !== null">
                        <tr><td colspan="15">Inkomsten</td></tr>

                        <tr>
                            <td>
                                <a @click="show.projectinvoices = !show.projectinvoices" style="color:#333;cursor:pointer;">
                                    <i :class="{'mdi':true, 'mdi-plus-circle-outline':!show.projectinvoices, 'mdi-minus-circle-outline':show.projectinvoices}"></i>
                                </a>
                            </td>
                            <td>Debiteuren projecten</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                {{ getCategoryTotal("projectinvoices", addmonth) | toCurrency(false) }}
                            </td>
                            <td style="max-width:100px;width:100px;" class="text-right">{{ totalProjectInvoices | toCurrency(false) }}</td>
                        </tr>
                        <tr v-show="show.projectinvoices">
                            <td colspan="2">&nbsp;</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                <a
                                    v-for="invoice in getProjectInvoices(addmonth)"
                                    :class="getInvoiceAnchorClass(invoice)"
                                    :title="getInvoiceAnchorTitle(invoice)"
                                    @click="openProjectInvoicesModal(invoice)"
                                    style="display:block;"
                                >{{ invoice.total | toCurrency(false) }}</a>
                            </td>
                            <td style="max-width:100px;width:100px;">&nbsp;</td>
                        </tr>

                        <tr>
                            <td>
                                <a @click="show.invoices = !show.invoices" style="color:#333;cursor:pointer;">
                                    <i :class="{'mdi':true, 'mdi-plus-circle-outline':!show.invoices, 'mdi-minus-circle-outline':show.invoices}"></i>
                                </a>
                            </td>
                            <td>Debiteuren</td>
                            <td v-for="addmonth in 12" :class="{'bg-info':isCurrentMonth(addmonth), 'text-right':true}">
                                {{ getCategoryTotal("invoices", addmonth) | toCurrency(false) }}
                            </td>
                            <td style="max-width:100px;width:100px;" class="text-right">{{ totalInvoices | toCurrency(false) }}</td>
                        </tr>
                        <tr v-show="show.invoices">
                            <td colspan="2">&nbsp;</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                <a
                                    v-for="invoice in getInvoices(addmonth)"
                                    :class="getInvoiceAnchorClass(invoice)"
                                    :title="getInvoiceAnchorTitle(invoice)"
                                    @click="openInvoicesModal(invoice)"
                                    style="display:block;"
                                >
                                    {{ invoice.total | toCurrency(false) }}
                                </a>
                            </td>
                            <td style="max-width:100px;width:100px;">&nbsp;</td>
                        </tr>

                        <tr>
                            <td colspan="2" class="text-right">Correcties (inkomsten)</td>
                            <td v-for="addmonth in 12" :class="{'bg-info':isCurrentMonth(addmonth), 'text-right':true}">
                                {{ monthlyIncomeCorrectionTotal(addmonth) | toCurrency(false) }}
                            </td>
                            <td style="max-width:100px;width:100px;" class="text-right">{{ 0 | toCurrency(false) }}</td>
                        </tr>

                        <tr>
                            <td colspan="2" class="text-right">Totaal inkomsten (inclusief BTW)</td>
                            <td v-for="addmonth in 12" :class="{'bg-info':isCurrentMonth(addmonth), 'text-right':true}">
                                {{ totalIncome(addmonth) | toCurrency(false) }}
                            </td>
                            <td style="max-width:100px;width:100px;" class="text-right">{{ totalProjectInvoices + totalInvoices | toCurrency(false) }}</td>
                        </tr>

                        <tr>
                            <td colspan="2" class="text-right">BTW op verkoopfacturen</td>
                            <td v-for="addmonth in 12" :class="{'bg-info':isCurrentMonth(addmonth), 'text-right':true}">
                                {{ getTaxes(addmonth) | toCurrency(false) }}
                            </td>
                            <td style="max-width:100px;width:100px;" class="text-right">{{ totalTaxes | toCurrency(false) }}</td>
                        </tr>

                        <tr><td colspan="15">&nbsp;</td></tr>
                    </tbody>
                    <tbody v-if="!loading">
                        <tr><td colspan="15">Uitgave</td></tr>

                        <tr>
                            <td>
                                <a @click="show.purchaseinvoices = !show.purchaseinvoices" style="color:#333;cursor:pointer;">
                                    <i :class="{'mdi':true, 'mdi-plus-circle-outline':!show.purchaseinvoices, 'mdi-minus-circle-outline':show.purchaseinvoices}"></i>
                                </a>
                            </td>
                            <td>Kosten derden</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                {{ getCategoryTotal("purchaseinvoices", addmonth) | toCurrency(false) }}
                            </td>
                            <td class="text-right">{{ totalPurchaseInvoices | toCurrency(false) }}</td>
                        </tr>
                        <tr v-show="show.purchaseinvoices">
                            <td colspan="2">&nbsp;</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                <a
                                    v-for="invoice in getPurchaseInvoices(addmonth)"
                                    :class="getInvoiceAnchorClass(invoice)"
                                    :title="getInvoiceAnchorTitle(invoice)"
                                    @click="openProjectInvoicesModal(invoice)"
                                    style="display:block;"
                                >
                                    {{ invoice.total | toCurrency(false) }}
                                </a>
                            </td>
                            <td style="max-width:100px;width:100px;">&nbsp;</td>
                        </tr>

                        <!--<tr>
                            <td>
                                <a @click="console.log('toggle')" style="color:#333;cursor:pointer;">
                                    <i class="mdi mdi-plus-circle-outline"></i>
                                </a>
                            </td>
                            <td>Personeel</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                {{ 0 | toCurrency(false) }}
                            </td>
                            <td style="max-width:100px;width:100px;" class="text-right">{{ 0 | toCurrency(false) }}</td>
                        </tr>-->

                        <tr v-for="category in categories" v-show="category.parent === null || showCategory(category.parent)">
                            <td>
                                <a v-if="category.parent === null" @click="toggleCategory(category.uuid)" style="color:#333;cursor:pointer;">
                                    <i v-if="!showCategory(category.uuid)" class="mdi mdi-plus-circle-outline"></i>
                                    <i v-else class="mdi mdi-minus-circle-outline"></i>
                                </a>
                            </td>
                            <td>{{ category.parent !== null ? '&ndash; ' : '' }}{{ category.name }}</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;font-weight:bold !important;" v-tooltip="'Dubbelklik op het getal om deze te wijzigen'" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                <business-liquidity-money-cell
                                    v-if="category.parent !== null"
                                    :cur-value="categoryTotal(category.uuid, addmonth)"
                                    @updateValue="setCategoryTotal(category.uuid, addmonth, $event, category.parent)"
                                ></business-liquidity-money-cell>
                                <span v-else>{{ categoryTotal(category.uuid, addmonth) | toCurrency(false) }}</span>
                            </td>
                            <td class="text-right">{{ totalCategory(category.uuid) | toCurrency(false) }}</td>
                        </tr>

                        <tr
                            v-for="row in rows"
                            v-if="row.id !== 'bankbalance'"
                        >
                            <td>&nbsp;</td>
                            <td>{{ row.name }}</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;font-weight:bold !important;" v-tooltip="'Dubbelklik op het getal om deze te wijzigen'" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                <business-liquidity-money-cell
                                    :cur-value="categoryTotal(row.id, addmonth)"
                                    @updateValue="setCategoryTotal(row.id, addmonth, $event)"
                                ></business-liquidity-money-cell>
                            </td>
                            <td class="text-right">{{ totalCategory(row.id) | toCurrency(false) }}</td>
                        </tr>

                        <tr>
                            <td>&nbsp;</td>
                            <td>Te betalen BTW</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                {{ totalTaxesToPayMonth(addmonth) | toCurrency(false) }}
                            </td>
                            <td class="text-right">{{ totalTaxesToPay | toCurrency(false) }}</td>
                        </tr>

                        <tr>
                            <td colspan="2" class="text-right">Correcties (uitgave)</td>
                            <td v-for="addmonth in 12" :class="{'bg-info':isCurrentMonth(addmonth), 'text-right':true}">
                                {{ monthlyExpensesCorrectionTotal(addmonth) | toCurrency(false) }}
                            </td>
                            <td style="max-width:100px;width:100px;" class="text-right">{{ 0 | toCurrency(false) }}</td>
                        </tr>

                        <tr>
                            <td class="text-right" colspan="2">Totaal uitgave:</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                {{ getMonthExpenses(addmonth) | toCurrency(false) }}
                            </td>
                            <td class="text-right">{{ totalExpenses | toCurrency(false) }}</td>
                        </tr>
                        <tr><td colspan="15">&nbsp;</td></tr>
                    </tbody>
                    <tbody v-if="!loading && null !== bankBalanceRow">
                        <tr><td colspan="15">Totalen</td></tr>
                        <tr v-if="null !== bankBalanceRow">
                            <td colspan="2" class="text-right">
                                Banksaldo eerste dag van de maand
                                <i class="mdi mdi-information-outline" v-tooltip="'Indien de banksaldo van de vorige maand op 0 euro staat, zal de waarde uit de cel \'(Banksaldo + inkomsten) - uitgave\' van de voorgaande maand gebruikt worden.'"></i>
                            </td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                <span>{{ getBankBalance(addmonth) | toCurrency(false) }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="text-right">Totaal inkomsten</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                {{ totalIncome(addmonth) | toCurrency(false) }}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="text-right">Totaal uitgave</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                {{ getMonthExpenses(addmonth) | toCurrency(false) }}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="text-right">(Banksaldo + inkomsten) - uitgave</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                {{ totalCalc(addmonth) | toCurrency(false) }}
                            </td>
                        </tr>
                        <tr v-if="null !== bankBalanceRow">
                            <td colspan="2" class="text-right">{{ bankBalanceRow.name }}</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;font-weight:bold !important;" v-tooltip="'Dubbelklik op het getal om deze te wijzigen'" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                <business-liquidity-money-cell
                                    :cur-value="categoryTotal(bankBalanceRow.id, addmonth)"
                                    @updateValue="setCategoryTotal(bankBalanceRow.id, addmonth, $event, bankBalanceRow.parent)"
                                ></business-liquidity-money-cell>
                            </td>
                        </tr>
                        <tr><td colspan="15">&nbsp;</td></tr>
                    </tbody>
                    <tbody v-if="!loading && null !== bankBalanceRow">
                        <tr><td colspan="15">Prognose</td></tr>
                        <tr v-if="null !== bankBalanceRow">
                            <td colspan="2" class="text-right">Banksaldo eerste dag van de maand</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                <span v-if="isFutureMonth(addmonth)">{{ getBankBalance(addmonth, true) | toCurrency(false) }}</span>
                                <span v-else>&ndash;</span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="text-right">Prognose (Inclusief BTW)</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                <span v-if="isFutureMonth(addmonth)">{{ prognoses(addmonth) | toCurrency(false) }}</span>
                                <span v-else>&ndash;</span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="text-right">Prognose BTW</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                <span v-if="isFutureMonth(addmonth)">{{ prognosesTax(addmonth) | toCurrency(false) }}</span>
                                <span v-else>&ndash;</span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="text-right">Totaal inkomsten</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                <span v-if="isFutureMonth(addmonth)">{{ totalIncome(addmonth) + prognoses(addmonth) | toCurrency(false) }}</span>
                                <span v-else>&ndash;</span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="text-right">Te betalen BTW</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                <span v-if="isFutureMonth(addmonth)">{{ prognosesTaxTotal(addmonth) | toCurrency(false) }}</span>
                                <span v-else>&ndash;</span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="text-right">Totaal uitgave</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                <span v-if="isFutureMonth(addmonth)">{{ getMonthExpenses(addmonth) + prognosesTax(addmonth - 1) | toCurrency(false) }}</span>
                                <span v-else>&ndash;</span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="text-right">(Banksaldo + inkomsten + prognose) - uitgave</td>
                            <td v-for="addmonth in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                <span v-if="isFutureMonth(addmonth)">{{ prognosesCalc(addmonth) | toCurrency(false) }}</span>
                                <span v-else>&ndash;</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="overlay" v-show="loading">
                <i class="fa fa-refresh fa-spin"></i>
            </div>
        </div>
        <div class="box box-solid">
            <div class="box-header">
                <h2 class="box-title">Correcties</h2>
            </div>
            <div class="box-body no-padding">
                <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Omschrijving</th>
                            <th>Maand</th>
                            <th>Bedrag</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="correctionRules.length === 0">
                            <td colspan="4">Er zijn geen correctie regels ingevoerd voor deze periode.</td>
                        </tr>
                        <tr v-for="rule in correctionRules">
                            <td v-text="rule.description"></td>
                            <td v-text="moment(rule.date).format('MM-YYYY')"></td>
                            <td>{{ rule.amount | toCurrency(false) }}</td>
                            <td>
                                <delete-button
                                    classes="btn btn-danger btn-xs"
                                    :url="links.deletecorrection + '/' + rule.id"
                                    :name="rule.description"
                                    @delete-completed="removeRuleFromCorrections(rule)"
                                    title="Correctieregel"
                                    v-tooltip="'Correctieregel verwijderen'"
                                ></delete-button>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>
                                <input type="text" class="form-control" v-model="correctionform.description" />
                            </td>
                            <td>
                                <monthly-picker
                                    dateFormat="MM-YYYY"
                                    inputClass="text"
                                    placeHolder="Selecteer"
                                    v-model="correctionform.month"
                                    :min="startOfCurrentYear"
                                    :max="endOfCurrentYear"
                                    class="monthlypickerbottom"
                                ></monthly-picker>
                            </td>
                            <td>
                                <money
                                    v-model="correctionform.amount"
                                    v-bind="money"
                                    class="form-control"
                                ></money>
                            </td>
                            <td>
                                <button
                                    class="btn btn-primary btn-sm"
                                    :disabled="!canAddCorrection"
                                    @click="addCorrection"
                                    v-tooltip="'Correct regel toevoegen'"
                                >
                                    <i class="mdi mdi-content-save"></i>
                                </button>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="overlay" v-show="loading || posting">
                <i class="fa fa-refresh fa-spin"></i>
            </div>
        </div>
        <business-invoice-modal ref="invoiceModal"></business-invoice-modal>
    </div>

</template>

<script>

    import Vue from 'vue';
    import axios from 'axios';
    import moment from 'moment';
    import BusinessLiquidityMoneyCell from "./LiquidityMoneyCell";
    import BusinessInvoiceModal from './InvoiceModal';
    import MonthlyPicker from 'vue-monthly-picker';
    import {Money} from 'v-money';
    import JsonExcel from 'vue-json-excel';

    export default {

        components: {
            BusinessLiquidityMoneyCell,
            BusinessInvoiceModal,
            MonthlyPicker,
            Money,
            JsonExcel,
        },

        computed: {

            bankBalanceRow(){
                return this.rows.filter(row => row.id === 'bankbalance')[0] || null;
            },

            categoryTotal: {
                get() {
                    return (category_uuid, addmonth) => {
                        if (addmonth !== 0) {
                            addmonth = moment(this.startperiod).add(addmonth - 1, "month").month() + 1;
                        }
                        if (!this.totals[category_uuid] || !this.totals[category_uuid][addmonth]) {
                            return 0;
                        }
                        return this.totals[category_uuid][addmonth];
                    };
                },
            },

            canAddCorrection() {
                return this.correctionform !== 0 &&
                    this.correctionform.description !== '' &&
                    this.correctionform.month !== null &&
                    this.posting !== true;
            },

            correctionRules() {
                let rules = [];
                for (let key in this.corrections.income) {
                    if (this.corrections.income.hasOwnProperty(key)) {
                        this.corrections.income[key].forEach(cor => rules.push(cor));
                    }
                }
                for (let key in this.corrections.expenses) {
                    if (this.corrections.expenses.hasOwnProperty(key)){
                        this.corrections.expenses[key].forEach(cor => rules.push(cor));
                    }
                }
                return rules;
            },

            defaultStartperiod() {
                return moment().startOf("month").subtract(3, "month");
            },

            getJSONData: {
                get() {
                    let data = [];
                    if (this.startperiod === null) {
                        return data;
                    }
                    let format = (value) => parseFloat(value / 100).toFixed(2);
                    let rows = [
                        {
                            name: "Maand",
                            fnct: (addmonth) => moment(this.startperiod).add(addmonth - 1, "month").format("YYYY-MM"),
                        },
                        {
                            name: "Debiteuren projecten",
                            fnct: (addmonth) => format(this.getCategoryTotal("projectinvoices", addmonth)),
                        },
                        {
                            name: "Debiteuren",
                            fnct: (addmonth) => format(this.getCategoryTotal("invoices", addmonth)),
                        },
                        {
                            name: "Correcties (inkomsten)",
                            fnct: (addmonth) => format(this.monthlyIncomeCorrectionTotal(addmonth)),
                        },
                        {
                            name: "Totaal inkomsten (inclusief BTW)",
                            fnct: (addmonth) => format(this.totalIncome(addmonth)),
                        },
                        {
                            name: "BTW op verkoopfacturen",
                            fnct: (addmonth) => format(this.getTaxes(addmonth)),
                        },
                        {
                            name: "Kosten derden",
                            fnct: (addmonth) => format(this.getCategoryTotal("purchaseinvoices", addmonth)),
                        },
                        {
                            name: "Te betalen BTW",
                            fnct: (addmonth) => format(this.totalTaxesToPayMonth(addmonth)),
                        },
                        {
                            name: "Correcties (Uitgave)",
                            fnct: (addmonth) => format(this.monthlyExpensesCorrectionTotal(addmonth)),
                        },
                        {
                            name: "Totale uitgave",
                            fnct: (addmonth) => format(this.getMonthExpenses(addmonth)),
                        },
                    ];
                    if (null !== this.bankBalanceRow) {
                        rows.push({
                            name: "Banksaldo eerste dag van de maand",
                            fnct: (addmonth) => format(this.getBankBalance(addmonth)),
                        });
                        rows.push({
                            name: "(Banksaldo + inkomsten) - uitgave",
                            fnct: (addmonth) => format(this.totalCalc(addmonth)),
                        });
                        rows.push({
                            name: "Banksaldo eerste dag van de maand",
                            fnct: (addmonth) => format(this.categoryTotal(this.bankBalanceRow.id, addmonth)),
                        });
                    }

                    rows.forEach(rowdata => {
                        let row = [];
                        row.push(rowdata.name);
                        for (let addmonth = 1; addmonth <= 12; addmonth++) {
                            row.push(rowdata.fnct(addmonth));
                        }
                        data.push(row);
                    });

                    return data;
                },
            },

            getSpanningYears() {
                let years = {};
                if (this.startperiod === null){
                    return years;
                }
                for (let i = 0; i < 12; i++) {
                    let year = moment(this.startperiod).add(i, "month").format("YYYY");
                    if (!years[year]) {
                        years[year] = 0;
                    }
                    years[year]++;
                }
                return years;
            },

            isResetable() {
                if (this.startperiod === null) {
                    return false;
                }
                return this.startperiod.format() !== this.defaultStartperiod.format();
            },

            totalExpenses(){
                let total = 0;
                for (let i = 0; i < 12; i++) {
                    total += this.getMonthExpenses(i);
                }
                return total;
            },

            totalInvoices() {
                let total = 0;
                for (let monthnr in this.invoices) {
                    if (this.invoices.hasOwnProperty(monthnr)){
                        this.invoices[monthnr].forEach(invoice => total += invoice.total);
                    }
                }
                return total;
            },

            totalProjectInvoices() {
                let total = 0;
                for (let monthnr in this.projectinvoices) {
                    if (this.projectinvoices.hasOwnProperty(monthnr)){
                        this.projectinvoices[monthnr].forEach(invoice => total += invoice.total);
                    }
                }
                return total;
            },

            totalPurchaseInvoices() {
                let total = 0;
                for (let monthnr in this.purchaseinvoices) {
                    if (this.purchaseinvoices.hasOwnProperty(monthnr)){
                        this.purchaseinvoices[monthnr].forEach(invoice => total += invoice.total);
                    }
                }
                return total;
            },

            totalTaxes() {
                let total = 0;
                for (let key in this.taxes) {
                    if (this.taxes.hasOwnProperty(key)) {
                        total += this.taxes[key];
                    }
                }
                return total;
            },

            totalTaxesToPay() {
                let total = 0;
                for (let i = 0; i < 12; i++) {
                    total += this.totalTaxesToPayMonth(i);
                }
                return total;
            },

            endOfCurrentYear() {
                return moment(this.startperiod,"YYYY").add(1, "year").endOf("year");
            },

            startOfCurrentYear() {
                return moment(this.startperiod,"YYYY").startOf("year");
            },

            postCorrectionForm() {
                let data = JSON.parse(JSON.stringify(this.correctionform));
                return {
                    description: data.description,
                    date: moment(data.month).format("YYYY-MM-DD"),
                    amount: data.amount * 100,
                }
            },
        },

        data() {
            return {
                amount:177543,
                categories:[],
                correctionform:{
                    description:'',
                    month:null,
                    amount:0,
                },
                corrections:[],
                excludedExpenses:[
                    "invoices",
                    "projectinvoices",
                    "bankbalance",
                ],
                invoices:[],
                links:[],
                loading:false,
                moment:moment,
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '€ ',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                posting:false,
                projectinvoices:[],
                prognosesdata:[],
                purchaseinvoices:[],
                rows:[],
                show: {
                    employees:false,
                    invoices:false,
                    projectinvoices:false,
                    purchaseinvoices:false,
                },
                startperiod:null,
                taxes:[],
                toggles:[],
                totals:[],
            }
        },

        methods: {

            addCorrection() {
                if (!this.canAddCorrection){
                    return;
                }
                this.posting = true;
                axios.post(this.links.addcorrection, this.postCorrectionForm)
                .then(resp => {
                    this.corrections = resp.data.data.corrections;
                    this.$snotify.success("Correctie is toegevoegd");
                    this.correctionform = {
                        description:'',
                        month:null,
                        amount:0,
                    };
                })
                .catch(() => this.$snotify.error("Er is een fout opgetreden bij het toevoegen van de correctie"))
                .finally(() => this.posting = false);
            },

            getBankBalance(addmonth, prognosis = false) {
                if (addmonth < 0) { // Required failsafe to prevent endless loop
                    return 0;
                }
                let prevmonthsbalance = this.categoryTotal(this.bankBalanceRow.id, addmonth - 1);

                // If the previous months bank balance is 0, try to get the calculated total
                if (prevmonthsbalance === 0 && (addmonth - 1) !== 0) {
                    return prognosis === true ?
                        this.prognosesCalc(addmonth - 1) :
                        this.totalCalc(addmonth - 1);
                }

                return prevmonthsbalance;
            },

            fixTotals(totals) {
                for (let i = 0; i < 12; i++) {
                    this.rows.forEach(row => {
                        if (!totals[row.id]) {
                            totals[row.id] = [];
                        }
                        if (!totals[row.id][i]){
                            totals[row.id][i] = 0;
                        }
                    });
                    this.categories.forEach(category => {
                        if (!totals[category.uuid]) {
                            totals[category.uuid] = [];
                        }
                        if (!totals[category.uuid][i]) {
                            totals[category.uuid][i] = 0;
                        }
                    })
                }
                return totals;
            },

            getCategoryTotal(category_uuid, addmonth) {
                addmonth = moment(this.startperiod).add(addmonth - 1, "month").month() + 1;
                if (!this.totals[category_uuid] || typeof this.totals[category_uuid][addmonth] === "undefined") {
                    return 0;
                }
                return this.totals[category_uuid][addmonth];
            },

            getExportName() {
                return 'liquidity-' + moment().format('YYYY-MM-DD-HH-mm');
            },

            getMonthExpenses(_addmonth) {
                let addmonth = moment(this.startperiod).add(_addmonth - 1, "month").month() + 1;
                let total = 0;
                for (let key in this.totals) {
                    if (this.totals.hasOwnProperty(key) && this.excludedExpenses.indexOf(key) === -1) {
                        if (/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(key)) {
                            if (null === this.categories.filter(category => category.uuid === key)[0].parent) {
                                total += this.totals[key][addmonth] || 0;
                            }
                        } else {
                            total += this.totals[key][addmonth] || 0;
                        }
                    }
                }
                // Add the taxes to pay too.
                total += this.totalTaxesToPayMonth(_addmonth);
                total += this.monthlyExpensesCorrectionTotal(_addmonth);
                return total;
            },

            setCategoryTotal(category_uuid, _addmonth, newvalue, parent_id = null){
                let addmonth = moment(this.startperiod).add(_addmonth - 1, "month").month() + 1;
                Vue.set(this.totals[category_uuid], addmonth, newvalue);
                if (parent_id !== null) {
                    let cur = this.getCategoryTotal(parent_id, addmonth);
                    Vue.set(this.totals[parent_id], addmonth, cur + newvalue);//TODO: we need to recalculate the entire category for this to work
                }
                axios.patch(this.links.update, {
                    element:category_uuid,
                    type:this.categories.filter(category => category.uuid === category_uuid).length > 0 ? "category" : category_uuid,
                    date:moment(this.startperiod).add(_addmonth - 1, "month").startOf("month").format("YYYY-MM-DD"),
                    value:newvalue,
                })
                .then(() => this.$snotify.success("De nieuwe waarde is opgeslagen!"))
                .catch(() => this.$snotify.error("Er is een fout opgetreden bij het opslaan van de waarde!"));
            },

            getLiquidity() {
                axios.get(this.liquidityUrl, {params:{startperiod:this.startperiod.format("YYYY-MM-DD")}})
                .then(resp => this.storeData(resp.data))
                .catch(() => this.$snotify.error("Er is een fout opgetreden bij het ophalen van de liquiditeits gegevens."))
                .finally(() => this.loading = false);
            },

            getInvoiceAnchorClass(invoice) {
                if (invoice.overdue === true) {
                    return "invoice-is-overdue";
                }
                if (invoice.paid === true) {
                    return "invoice-is-paid";
                }
                if (invoice.send === true) {
                    return "invoice-is-send";
                }
                return "invoice-is-pending";
            },

            getInvoiceAnchorTitle(invoice) {
                if (invoice.overdue === true) {
                    return "Factuur is niet binnen de betaaltermijn voldaan!";
                }
                if (invoice.paid === true) {
                    return "Factuur is voldaan";
                }
                if (invoice.send === true) {
                    return "Factuur is verzonden";
                }
                return "Te versturen";
            },

            getInvoices(addmonth) {
                addmonth = moment(this.startperiod).add(addmonth - 1, "month").month() + 1;
                return !this.invoices[addmonth] ? [] : this.invoices[addmonth];
            },

            getProjectInvoices(addmonth) {
                addmonth = moment(this.startperiod).add(addmonth - 1, "month").month() + 1;
                return !this.projectinvoices[addmonth] ? [] : this.projectinvoices[addmonth];
            },

            getPurchaseInvoices(addmonth) {
                addmonth = moment(this.startperiod).add(addmonth - 1, "month").month() + 1;
                return !this.purchaseinvoices[addmonth] ? [] : this.purchaseinvoices[addmonth];
            },

            getTaxes(addmonth) {
                addmonth = moment(this.startperiod).add(addmonth - 1, "month").month() + 1;
                return !this.taxes[addmonth] ? 0 : this.taxes[addmonth]
            },

            monthlyExpensesCorrectionTotal(addmonth) {
                addmonth = moment(this.startperiod).add(addmonth - 1, "month").month() + 1;
                if (!this.corrections.expenses || !this.corrections.expenses[addmonth]) {
                    return 0;
                }
                let total = 0;
                this.corrections.expenses[addmonth].forEach(correction => total += correction.amount);
                return total * -1;
            },

            monthlyIncomeCorrectionTotal(addmonth) {
                addmonth = moment(this.startperiod).add(addmonth - 1, "month").month() + 1;
                if (!this.corrections.income || !this.corrections.income[addmonth]) {
                    return 0;
                }
                let total = 0;
                this.corrections.income[addmonth].forEach(correction => total += correction.amount);
                return total;
            },

            isCurrentMonth(addmonth) {
                let addto = addmonth - 1;
                return moment().isBetween(
                    moment(this.startperiod).add(addto, "month").startOf("month"),
                    moment(this.startperiod).add(addto, "month").endOf("month")
                );
            },

            isFutureMonth(addmonth) {
                return moment().isBefore(
                    moment(this.startperiod).add(addmonth - 1, "month").startOf("month")
                );
            },

            move(newstartperiod) {
                this.loading = true;
                this.tasks = [];
                this.startperiod = newstartperiod.startOf("month");
                this.getLiquidity();
            },

            moveBackwardsYear() {
                this.move(moment(this.startperiod).add(12,"hours").subtract(1, "year"));
            },

            moveBackwards() {
                this.move(moment(this.startperiod).add(12,"hours").subtract(1, "month"));
            },

            moveForward() {
                this.move(moment(this.startperiod).add(12,"hours").add(1, "month"));
            },

            moveForwardYear() {
                this.move(moment(this.startperiod).add(12,"hours").add(1, "year"));
            },

            moveReset() {
                this.move(this.defaultStartperiod);
            },

            openInvoicesModal(invoice) {
                let date = '';
                if (invoice.paid_at) { date = invoice.paid_at }
                else if (invoice.date) { date = invoice.date }
                else { date = invoice.expected_at }
                this.$refs.invoiceModal.openModal(invoice.paths.elementsUrl,{
                    startperiod:date,
                    liquidity:true,
                }, invoice);
            },

            openProjectInvoicesModal(invoice) {
                this.$refs.invoiceModal.openModal(invoice.paths.taskurl, {}, invoice);
            },

            removeRuleFromCorrections(rule) {
                let month = moment(rule.date).format("M");
                if (rule.amount >= 0) {
                    this.corrections.income[month].splice(
                        this.corrections.income[month].findIndex(cor => cor.id === rule.id),
                        1
                    );
                } else {
                    this.corrections.expenses[month].splice(
                        this.corrections.expenses[month].findIndex(cor => cor.id === rule.id),
                        1
                    );
                }
            },

            setStartperiod(startperiod) {
                this.startperiod = startperiod;
            },

            setYearView(year) {
                this.move(moment().year(year).startOf("year"));
            },

            showCategory(category_uuid){
                return this.toggles.indexOf(category_uuid) !== -1;
            },

            storeData(data){
                this.categories = data.data.categories;
                this.corrections = data.data.corrections;
                this.invoices = data.data.invoices;
                this.projectinvoices = data.data.projectinvoices;
                this.purchaseinvoices = data.data.purchaseinvoices;
                this.prognosesdata = data.data.prognoses;
                this.rows = data.data.rows;
                this.links = data.data._links;
                this.taxes = data.data.taxes;
                this.totals = this.fixTotals(data.data.totals);
            },

            toggleCategory(category_uuid) {
                if (!this.showCategory(category_uuid)) {
                    this.toggles.push(category_uuid);
                } else {
                    this.toggles.splice(this.toggles.findIndex(to => to === category_uuid), 1);
                }
            },

            totalCategory(category_uuid) {
                let total = 0;
                for (let i = 1; i <= 12; i++) {
                    total += this.totals[category_uuid][i] || 0;
                }
                return total;
            },

            totalCalc(addmonth) {
                return (this.getBankBalance(addmonth) + this.totalIncome(addmonth)) - this.getMonthExpenses(addmonth);
            },

            totalIncome(addmonth) {
                return this.getCategoryTotal("projectinvoices", addmonth) +
                    this.getCategoryTotal("invoices", addmonth) +
                    this.monthlyIncomeCorrectionTotal(addmonth);
            },

            totalTaxesToPayMonth(addmonth) {
                if (addmonth === 1) {
                    return this.taxes[0] || 0;
                }
                return this.getTaxes(addmonth - 1);
            },

            prognoses(addmonth) {
                addmonth = moment(this.startperiod).add(addmonth - 1, "month").month() + 1;
                return this.prognosesdata[addmonth].total || 0;
            },

            prognosesCalc(addmonth) {
                return (this.getBankBalance(addmonth, true) +
                    this.totalIncome(addmonth) +
                    this.prognoses(addmonth)) -
                    (this.getMonthExpenses(addmonth) + this.prognosesTax(addmonth - 1));
            },

            prognosesTax(addmonth) {
                addmonth = moment(this.startperiod).add(addmonth - 1, "month").month() + 1;
                if (!this.prognosesdata[addmonth]) {
                    return 0;
                }
                return this.prognosesdata[addmonth].tax_total || 0;
            },

            prognosesTaxTotal(addmonth) {
                return this.totalTaxesToPayMonth(addmonth) + this.prognosesTax(addmonth - 1);
            },

        },

        mounted() {
            this.setStartperiod(this.defaultStartperiod);
            this.getLiquidity();
        },

        name:"BusinessLiquidity",

        props: {
            liquidityUrl: {
                required:true,
                type:String,
            },
        }

    }

</script>

<style>

    .monthlypickerbottom .date-popover {
        bottom:18px;
    }

</style>
